import { render } from "./App.vue?vue&type=template&id=7bea3bbc"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./styles/theme.less?vue&type=style&index=0&lang=less"
import "./styles/var.less?vue&type=style&index=1&lang=less"
import "./styles/weird.less?vue&type=style&index=2&lang=less"
import "./styles/global.less?vue&type=style&index=3&lang=less"
script.render = render

export default script